
import { ReactAutosuggestGeocoder } from './geocoder';

import './styles/index.scss';

export { ReactAutosuggestGeocoder };



// WEBPACK FOOTER //
// ./node_modules/react-autosuggest-geocoder/src/index.js